import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  userSchema,
  type ChangePasswordRequest,
  type UpdateMeRequest,
  type User,
} from '@witty-board/shared'
import { z } from 'zod'
import { apiRequest, apiRequestVoid, apiUploadRequest } from './client.js'
import { meQueryKey } from './auth.js'

export const usersQueryKey = ['users'] as const

async function fetchUsers(): Promise<User[]> {
  return apiRequest('/users', z.array(userSchema))
}

/** Lista de usuarios para resolver nombre/avatar de un `assigneeId` en el tablero. */
export function useUsersQuery() {
  return useQuery({
    queryKey: usersQueryKey,
    queryFn: fetchUsers,
    staleTime: 60_000,
  })
}

/** Página de perfil (CLAUDE.md §6, fase 5): nombre, idioma y avatar. */
export function useUpdateMeMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: UpdateMeRequest) =>
      apiRequest('/users/me', userSchema, { method: 'PATCH', body: request }),
    onSuccess: (updated) => {
      queryClient.setQueryData(meQueryKey, updated)
    },
  })
}

export function useUploadAvatarMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (file: File) => apiUploadRequest('/users/me/avatar', userSchema, file),
    onSuccess: (updated) => {
      queryClient.setQueryData(meQueryKey, updated)
    },
  })
}

export function useChangePasswordMutation() {
  return useMutation({
    mutationFn: (request: ChangePasswordRequest) =>
      apiRequestVoid('/users/me/password', { method: 'POST', body: request }),
  })
}
